import { render, staticRenderFns } from "./ProjectSettings.vue?vue&type=template&id=bbede5dc&scoped=true"
import script from "./ProjectSettings.vue?vue&type=script&lang=js"
export * from "./ProjectSettings.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettings.vue?vue&type=style&index=0&id=bbede5dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbede5dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbede5dc')) {
      api.createRecord('bbede5dc', component.options)
    } else {
      api.reload('bbede5dc', component.options)
    }
    module.hot.accept("./ProjectSettings.vue?vue&type=template&id=bbede5dc&scoped=true", function () {
      api.rerender('bbede5dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProjectSettings.vue"
export default component.exports